import React from 'react';
import type { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { Link } from '@rover/kibble/core';

export const ACTIVATE_ACCOUNT_TITLE_TEXT = msg`Activate your account`;
export const ACTIVATE_ACCOUNT_HEADER_TEXT = msg`ACTIVATE YOUR ACCOUNT`;
export const ONBOARDING_HEADER_TEXT = (isSitter: boolean): MessageDescriptor => {
  if (isSitter) {
    return msg`A few last steps...`;
  }
  return msg`You’re all set!`;
};

export const ONBOARDING_TEXT = (isSitter: boolean): MessageDescriptor[] => {
  if (isSitter) {
    return [
      msg`Your new sitter account now has all your existing bookings, clients, and settings. You can complete any previously booked stays and message all of your clients.`,
      msg`All future bookings will be managed from your sitter account on Rover. Continue to Rover to complete a few additional steps so your services continue smoothly. While you’re there, take a moment to explore your new tools and settings.`,
    ];
  }
  return [msg`Ready to explore? Take a look around to see what's new!`];
};

export const ACTIVATE_ACCOUNT_TEXT = msg`Cat in a Flat is now part of the Rover Group. Activate your account to access powerful new search features, improved booking management, and a wider range of pet care options both in your neighborhood and around the world.`;
export const TOS_TEXT = (tosUrl?: string, privacyPolicyUrl?: string): JSX.Element => (
  <Trans>
    By checking this box, I agree to Rover{' '}
    <Link asInlineLink href={tosUrl ?? '/terms/tos/'} target="_blank">
      {' '}
      Terms of Service
    </Link>{' '}
    and{' '}
    <Link asInlineLink href={privacyPolicyUrl ?? '/terms/privacy/'} target="_blank">
      {' '}
      Privacy Statement
    </Link>{' '}
    and confirm that I am 18 years of age or older.
  </Trans>
);

export const MARKETING_EMAILS_TEXT = (): JSX.Element => (
  <Trans>
    Yes, I want to receive marketing emails and messages from Rover and its affiliates. I can
    unsubscribe at any time.
  </Trans>
);

export const ACTIVATION_BUTTON_TEXT = msg`Accept and activate my account`;
export const SEARCH_BUTTON_TEXT = msg`Search for pet care`;
export const PROFILE_BUTTON_TEXT = msg`Complete my profile on Rover`;
export const VIEW_BOOKINGS_BUTTON_TEXT = (isUserProvider: boolean): MessageDescriptor =>
  isUserProvider ? msg`View my bookings on Rover` : msg`View my bookings`;
export const FAQS_SECTION_SUBHEADER_TEXT = (
  helpCenterUrl: string,
  onHelpCenterClick?: () => void
): JSX.Element => (
  <Trans>
    Visit the{' '}
    <Link asInlineLink href={helpCenterUrl} target="_blank" onPress={onHelpCenterClick}>
      Help Center
    </Link>{' '}
    if you have additional questions.
  </Trans>
);

export const CONSENT_ERROR_TEXT = msg`Something went wrong. Please try again.`;
export const TOS_REQUIRED_ERROR_TEXT = msg`Please accept the Terms of Service to continue`;
export const LOADING_TEXT = msg`Loading your account details`;

export const ROVERLAPPER_MERGE_HEADER_TEXT = (brandName: string): MessageDescriptor =>
  msg`Merge your ${brandName} Account with your Rover Account`;
export const ROVERLAPPER_MERGE_BODY_TEXT = (brandName: string): MessageDescriptor =>
  msg`Merge your ${brandName} account to bring your bookings, messages and reviews to Rover. Questions? Look at the FAQ section below.`;
export const ROVERLAPPER_MERGE_BUTTON_TEXT = msg`Move my data`;
export const ROVERLAPPER_MERGE_ERROR_TEXT = msg`Something went wrong. Please try again.`;
export const ROVERLAPPER_MERGE_SUCCESS_TEXT = msg`It may take a few minutes for all of your information to appear. If it has been an hour and you still don't see everything, please contact support.`;
